import { render, staticRenderFns } from "./ReviewDeposit.vue?vue&type=template&id=ad72fb98&"
import script from "./ReviewDeposit.vue?vue&type=script&lang=js&"
export * from "./ReviewDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports